export default __webpack_public_path__ + "media/we_offer_icon.12adb971.svg";